<script module lang="ts">
  export {
    handleMessageActions,
    refresh,
    type MessageAction,
  } from './utils/action';
  import { marked, type RendererObject } from 'marked';
  const renderer: RendererObject = {
    link(tokens) {
      const link = marked.Renderer.prototype.link.call(this, tokens);
      return link.replace(
        '<a',
        "<a target='_blank' rel='nofollow noopener noreferrer' "
      );
    },
  };
  marked.use({ renderer });
</script>

<script lang="ts">
  import { renderEmojis } from '@pin/emotes/emoji';
  import { renderEmotes } from '@pin/emotes/emote';
  import DOMPurify from 'dompurify';
  import { renderActions } from './utils/action';
  import { renderLinks } from './utils/link';

  interface Props {
    text?: string;
    markdown?: string;
    as?: string;
    baseUrl?: string;
    links?: boolean;
    actions?: boolean;
  }

  let {
    text,
    markdown,
    as = 'span',
    baseUrl = import.meta.env.VITE_EMOTES_BASE_URL ?? '/',
    links = false,
    actions = false,
  }: Props = $props();
  let el: HTMLElement | null = $state(null);

  $effect(() => {
    const currentText = text;
    const currentMarkdown = markdown;

    if (!el) return;

    if (currentText) {
      // eslint-disable-next-line svelte/no-dom-manipulating
      el.textContent = currentText;
      if (links) renderLinks(el);
    } else if (currentMarkdown) {
      const html = marked(currentMarkdown, { async: false }) as string;
      // eslint-disable-next-line svelte/no-dom-manipulating
      el.innerHTML = DOMPurify.sanitize(html, {
        ADD_ATTR: ['target'],
      });
    } else {
      // eslint-disable-next-line svelte/no-dom-manipulating
      el.textContent = '';
      return;
    }

    if (actions) renderActions(el);
    renderEmotes(baseUrl, el);
    renderEmojis(baseUrl, el);
  });
</script>

<svelte:element this={as} bind:this={el} class="root"></svelte:element>

<style>
  :global(.root h1),
  :global(.root h2),
  :global(.root h3),
  :global(.root h4),
  :global(.root h5),
  :global(.root h6),
  :global(.root p),
  :global(.root ul),
  :global(.root ol),
  :global(.root pre),
  :global(.root li),
  :global(.root code) {
    margin: 0;
    padding: 0;
  }

  :global(.root ul),
  :global(.root ol) {
    list-style-position: inside;
    padding-left: 1em;
  }

  :global(.root pre),
  :global(.root code) {
    font-family: monospace;
  }

  :global(.root pre) {
    white-space: pre-wrap;
  }
</style>
